import React from 'react';
import PropTypes from 'prop-types';
import Layout from 'components/Layout/layout.jsx';

// ----------------------------------
// global css
// ----------------------------------
import 'css/global.css';
import 'css/rodal.css';

// ----------------------------------
// logger
// ----------------------------------
const CrossLoggerPlugin = require('cross-logger-plugin');

const logger = new CrossLoggerPlugin(
  `App:${__filename.replace(__dirname, '')}`,
);

const ContextType = {
  // Enables critical path CSS rendering
  // https://github.com/kriasoft/isomorphic-style-loader
  // insertCss: PropTypes.func.isRequired,
  // Universal HTTP client
  // fetch: PropTypes.func.isRequired,
  pathname: PropTypes.string.isRequired,
  query: PropTypes.object,
  params: PropTypes.object,
  body: PropTypes.object,
  initializeData: PropTypes.object,
};

class App extends React.PureComponent {
  static propTypes = {
    context: PropTypes.shape(ContextType).isRequired,
    children: PropTypes.element.isRequired,
  };

  // constructor(props) {
  //   super(props);
  // }

  static childContextTypes = ContextType;

  getChildContext() {
    return this.props.context;
  }

  // render() {
  //   return <Layout context={this.props.context} />;
  // }

  render() {
    // NOTE: If you need to add or modify header, footer etc. of the app,
    // please do that inside the Layout component.
    return React.Children.only(this.props.children);
  }
}

export default App;
